import React, { Fragment } from "react";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { apiJson } from "../../../../api/Api";

import "./bankform.scss";

const BankSchema = Yup.object().shape({
  bank_account_title: Yup.string().required("Required"),
  bank_account_no: Yup.number().required("Required"),
  bank_account_iban: Yup.string().required("Required"),
  bank_name: Yup.string().required("Required"),
});

const BankForm = (props) => {
  const values = {
    bank_account_title: props.store?.bank_account_title || "",
    bank_account_no: props.store?.bank_account_no || "",
    bank_account_iban: props.store?.bank_account_iban || "",
    bank_name: props.store?.bank_name || "",
  };

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const nextClick = (values) => {
    apiJson.createStore
      .updateStoreBank({
        bank_account_title: values.bank_account_title,
        bank_account_no: values.bank_account_no,
        bank_account_iban: values.bank_account_iban,
        bank_name: values.bank_name
      })
      .then(response => {
        if (response.success) {
          props.set_store({
            store: {
              ...props.store,
              bank_account_title: values.bank_account_title,
              bank_account_no: values.bank_account_no,
              bank_account_iban: values.bank_account_iban,
              bank_name: values.bank_name,
            },
          });
          props.set_page_state({ pageState: { id: 5 } });
        }
        else {
          message = response.message;
          showError();
        }
      })
      .catch(error => {
        message = "Something went wrong!";
        showError();
      });
  };

  return (
    <Fragment>
      <Formik
        initialValues={values}
        validationSchema={BankSchema}
        isValidating={true}
        onSubmit={(values) => nextClick(values)}
      >
        {({ values }) => {
          return (
            <Form className="form mx-auto">
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="bank_name"
                type="text"
                label="Bank Name"
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="bank_account_title"
                type="text"
                label="Account Title"
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="bank_account_no"
                type="text"
                label="Account No."
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="bank_account_iban"
                type="text"
                label="Account IBN"
              />
              <br />
              <button key={98374} type="submit" className="next-button">
                Next
              </button>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(mapStateToProps, mapDispatchTopProps)(BankForm);
